import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import * as x from "react";
import { forwardRef as be, useState as G, useRef as U, useMemo as Z, useCallback as he, useEffect as S, useImperativeHandle as ge } from "react";
import { c as j } from "./index-DkZ16bcJ.mjs";
import { l as oe } from "./lodash-5ofSKtz3.mjs";
import { d as xe } from "./index-DH8DM7A9.mjs";
import { f as P } from "./index-LyFokDcn.mjs";
import { F as ve } from "./flex-Cc3osQLf.mjs";
import { g as B } from "./index-lgh2EImO.mjs";
import { m as ye } from "./tss-DN0acMKN.mjs";
import { M as J, d as K } from "./constants-CnFYFetN.mjs";
import { T as V } from "./Typography-DfkimCSn.mjs";
import { I as we } from "./icon-button-BxDvkq_l.mjs";
import { P as Re } from "./Paper-J9MVFbwr.mjs";
import { I as je } from "./X12x12-BDdS6yjO.mjs";
import { P as Ee } from "./Popper-X3MMNHL3.mjs";
import { u as Ie } from "./useForkRef-C_4o__cU.mjs";
import { g as $e } from "./getReactElementRef-B4Mdq17D.mjs";
import { u as ke } from "./useEventCallback-B4gn-DZo.mjs";
import { o as H } from "./ownerDocument-CUrv0DIK.mjs";
import { F as Ce } from "./Fade-B7C8Y6jW.mjs";
function ee(i) {
  return i.substring(2).toLowerCase();
}
function Se(i, t) {
  return t.documentElement.clientWidth < i.clientX || t.documentElement.clientHeight < i.clientY;
}
function Fe(i) {
  const {
    children: t,
    disableReactTree: a = !1,
    mouseEvent: o = "onClick",
    onClickAway: l,
    touchEvent: e = "onTouchEnd"
  } = i, h = x.useRef(!1), m = x.useRef(null), g = x.useRef(!1), y = x.useRef(!1);
  x.useEffect(() => (setTimeout(() => {
    g.current = !0;
  }, 0), () => {
    g.current = !1;
  }), []);
  const I = Ie($e(t), m), p = ke((s) => {
    const c = y.current;
    y.current = !1;
    const f = H(m.current);
    if (!g.current || !m.current || "clientX" in s && Se(s, f))
      return;
    if (h.current) {
      h.current = !1;
      return;
    }
    let R;
    s.composedPath ? R = s.composedPath().includes(m.current) : R = !f.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      s.target
    ) || m.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      s.target
    ), !R && (a || !c) && l(s);
  }), v = (s) => (c) => {
    y.current = !0;
    const f = t.props[s];
    f && f(c);
  }, w = {
    ref: I
  };
  return e !== !1 && (w[e] = v(e)), x.useEffect(() => {
    if (e !== !1) {
      const s = ee(e), c = H(m.current), f = () => {
        h.current = !0;
      };
      return c.addEventListener(s, p), c.addEventListener("touchmove", f), () => {
        c.removeEventListener(s, p), c.removeEventListener("touchmove", f);
      };
    }
  }, [p, e]), o !== !1 && (w[o] = v(o)), x.useEffect(() => {
    if (o !== !1) {
      const s = ee(o), c = H(m.current);
      return c.addEventListener(s, p), () => {
        c.removeEventListener(s, p);
      };
    }
  }, [p, o]), /* @__PURE__ */ r.jsx(x.Fragment, {
    children: /* @__PURE__ */ x.cloneElement(t, w)
  });
}
function Te(i) {
  const t = i ? i.querySelector(
    'input:not([type="hidden"]):not(:disabled), textarea:not(:disabled), .fab-Select [role="button"]:not(:disabled), select:not(:disabled), a:not(:disabled), button:not(:disabled):not([aria-label~="close" i])'
  ) : null, a = i && !t ? i.querySelector('button:not(:disabled)[aria-label~="close" i]') : null;
  t ? t.focus() : a && a.focus();
}
const Ae = "1em", E = "0.71em", Ne = 200, Oe = ye()((i, t, a) => {
  const { mixins: o, mode: l, palette: e, spacing: h, transitions: m, typography: g } = i, { arrowFill: y, hasCloseButton: I, hasMaxWidth: p, noPadding: v, title: w, zIndex: s } = t;
  function c(f) {
    const { title: R, hasCloseButton: b, noPadding: M } = f;
    let F = h(2.5, 1.5, 2.5, 2.5);
    return M ? F = void 0 : (R || b) && (F = h(0, 1.5, 2.5, 2.5)), F;
  }
  return P.ifFeature(
    "encore",
    {
      root: {
        zIndex: s
      },
      arrow: {},
      arrowBordered: {},
      arrowFocused: {},
      closeButton: {
        marginLeft: "auto"
      },
      constraint: {},
      content: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        padding: c({ title: w, hasCloseButton: I, noPadding: v })
      },
      paper: {},
      paperBordered: {},
      paperFocused: {},
      popover: {
        backgroundColor: e.common.white,
        border: `1px solid ${e.gray[300]}`,
        borderRadius: h(1),
        boxShadow: `3px 3px 10px 2px ${o.alpha(e.gray[900], 0.1)}`,
        boxSizing: "border-box",
        lineHeight: g.medium.lineHeight,
        maxWidth: p ? "324px" : void 0,
        zIndex: 1
      },
      popoverNoMaxWidth: {},
      title: {
        display: "inline"
      },
      titleContainer: {}
    },
    {
      root: {
        outline: l === J.Dye ? `1px solid ${K.main}` : void 0,
        zIndex: s,
        [`&[data-popper-placement*="bottom"] .${a.arrow}`]: {
          top: 0,
          left: 0,
          marginTop: `-${E}`,
          "&::before": {
            transformOrigin: "0 100%"
          }
        },
        [`&[data-popper-placement*="left"] .${a.arrow}`]: {
          right: 0,
          marginRight: `-${E}`,
          height: "1em",
          width: E,
          "&::before": {
            transformOrigin: "0 0"
          }
        },
        [`&[data-popper-placement*="right"] .${a.arrow}`]: {
          left: 0,
          marginLeft: `-${E}`,
          height: "1em",
          width: E,
          "&::before": {
            transformOrigin: "100% 100%"
          }
        },
        [`&[data-popper-placement*="top"] .${a.arrow}`]: {
          bottom: 0,
          left: 0,
          marginBottom: `-${E}`,
          "&::before": {
            transformOrigin: "100% 0"
          }
        },
        [`&[data-popper-placement*="bottom"] .${a.popover}`]: {
          transformOrigin: "center top"
        },
        [`&[data-popper-placement*="left"] .${a.popover}`]: {
          transformOrigin: "right center"
        },
        [`&[data-popper-placement*="right"] .${a.popover}`]: {
          transformOrigin: "left center"
        },
        [`&[data-popper-placement*="top"] .${a.popover}`]: {
          transformOrigin: "center bottom"
        }
      },
      popover: {
        maxWidth: "294px"
      },
      popoverNoMaxWidth: {
        maxWidth: "none"
      },
      arrow: {
        filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.1))",
        fontSize: "18px",
        boxSizing: "border-box",
        color: y || e.common.white,
        height: E,
        outline: l === J.Dye ? `1px solid ${K.main}` : void 0,
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        width: Ae,
        zIndex: 0,
        "&:before": {
          border: o.border(1, e.grey[300]),
          content: '""',
          margin: "auto",
          display: "block",
          width: "100%",
          height: "100%",
          backgroundColor: "currentColor",
          transform: "rotate(45deg)"
        }
      },
      arrowBordered: {
        "&&": {
          "&:before": {
            ...o.popoverSurface(e)
          }
        }
      },
      arrowFocused: {
        "&&": {
          "&:before": {
            border: o.border(1, e.primary.lighter),
            boxShadow: `0 0 0 2px ${o.alpha(e.primary.lightest, 0.35)}`
          }
        }
      },
      titleContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start"
      },
      closeButton: {
        fill: e.grey[600],
        padding: "12px",
        transition: m.create("fill", { duration: 200 }),
        ...o.buttonReset,
        "&:active, &:focus": {
          outline: 0
        },
        "&:hover": {
          fill: e.grey[800]
        }
      },
      content: {
        backgroundColor: "inherit",
        borderRadius: "inherit",
        overflowX: "hidden",
        overflowY: "auto",
        position: "relative",
        zIndex: 1
      },
      constraint: {
        padding: v ? 0 : " 0px 24px 20px 24px"
      },
      paper: {
        backgroundColor: e.common.white,
        border: o.border(1, e.grey[300]),
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        color: e.grey[900],
        fontWeight: g.fontWeightRegular,
        overflowX: "visible",
        overflowY: "visible",
        pointerEvents: "auto",
        position: "relative",
        ...g.body2,
        "&.MuiPaper-rounded": {
          borderRadius: "2px"
        }
      },
      paperBordered: {
        ...o.popoverSurface(e)
      },
      paperFocused: {
        "&&": {
          border: o.border(1, e.primary.lighter),
          boxShadow: `0 0 0 2px ${o.alpha(e.primary.lightest, 0.35)}`
        }
      },
      title: {
        padding: "9px 0px 5px 24px",
        marginBottom: "0"
      }
    }
  );
}), te = (i, t) => t.reduce((a, o) => (a[o[i]] = o, a), {}), Be = (i, t = [], a = []) => {
  const o = oe.merge(te(i, t), te(i, a));
  return Object.values(o);
}, ot = be(
  ({
    action: i,
    anchorEl: t,
    arrowFill: a,
    autofocus: o = !0,
    children: l,
    classes: e = {},
    className: h,
    container: m,
    disableOuterClickOnClose: g = !1,
    disablePortal: y = !1,
    hasArrow: I = !0,
    hasCloseButton: p = !0,
    id: v,
    isRounded: w = !0,
    modifiers: s = [],
    hasMaxWidth: c = !0,
    noPadding: f,
    offset: R = 11,
    onClose: b,
    onEnter: M,
    onEntered: F,
    onEntering: re,
    onExit: ne,
    onExited: ie,
    onExiting: ae,
    onFlip: D,
    open: u,
    PaperProps: se = {},
    placement: _ = "top",
    title: k,
    titleComponent: q = "h4",
    variant: O,
    ...de
  }, T) => {
    const [L, ce] = G(u), [le, X] = G(null), C = U(null), A = Z(() => v || oe.uniqueId("popover-"), [v]), W = `${A}-title`, Y = `${A}-children`, N = he(() => {
      const n = B(t);
      n && n.focus();
    }, [t]), pe = Z(() => u ? xe.getMaxZIndex() + 10 : 0, [u, L]), { classes: d } = Oe({ arrowFill: a, hasCloseButton: p, hasMaxWidth: c, noPadding: f, title: k, zIndex: pe }), Q = U(_);
    S(() => {
      L && ce(!1);
    }, [L]), S(() => {
      const n = (me) => {
        me.key === "Escape" && u && typeof b == "function" && (N(), b());
      };
      return document.addEventListener("keyup", n), () => document.removeEventListener("keyup", n);
    }, [N, b, u]);
    const z = typeof T != "function" ? T == null ? void 0 : T.current : null;
    if (S(() => {
      o && u && z && Te(z);
    }, [o, u, z]), S(() => {
      const n = B(t);
      n && (n.setAttribute("aria-expanded", u.toString()), u ? n.setAttribute("aria-controls", A) : n.removeAttribute("aria-controls"));
    }, [t, A, u]), S(() => {
      const n = B(t);
      n && n.setAttribute("aria-haspopup", "dialog");
    }, [t]), ge(
      i,
      () => u ? {
        updatePosition: () => {
          if (C != null && C.current) {
            const n = C.current;
            n.update && n.update();
          }
        }
      } : null,
      [u, C]
    ), S(() => {
      !B(t) && t !== null && console.error("Invalid `anchorEl` prop supplied to Popover. Must be a ReactElement.");
    }, [t]), t === null)
      return null;
    const ue = [
      {
        name: "arrow",
        enabled: I,
        options: {
          element: le
        }
      },
      {
        name: "flip",
        enabled: !0
      },
      {
        name: "preventOverflow",
        enabled: P.ifFeature("encore", !0, !1)
      },
      {
        name: "hide",
        enabled: !1
      },
      {
        name: "onFlip",
        enabled: !0,
        phase: "afterWrite",
        fn({ state: n }) {
          D && n.placement !== Q.current && (Q.current = n.placement, D(n.placement));
        }
      },
      {
        name: "offset",
        options: {
          offset: [0, R]
        }
      }
    ], fe = P.ifFeature(
      "encore",
      /* @__PURE__ */ r.jsxs("div", { className: d.popover, children: [
        (k || p) && /* @__PURE__ */ r.jsxs(
          ve,
          {
            gap: 1.5,
            justifyContent: "space-between",
            paddingBottom: 1,
            paddingLeft: 2.5,
            paddingRight: 1.5,
            paddingTop: 2.5,
            children: [
              k && /* @__PURE__ */ r.jsx(
                V,
                {
                  className: d.title,
                  color: "primary",
                  component: q,
                  id: W,
                  variant: "h4",
                  children: k
                }
              ),
              p && /* @__PURE__ */ r.jsx("div", { className: d.closeButton, children: /* @__PURE__ */ r.jsx(
                we,
                {
                  ariaLabel: window.jQuery ? $.__("Close popover") : "Close popover",
                  color: "secondary",
                  icon: "xmark-solid",
                  onClick: () => {
                    typeof b == "function" && (N(), b());
                  },
                  size: "teenie",
                  type: "button",
                  variant: "outlined"
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ r.jsx("div", { className: d.content, id: Y, children: l && typeof l == "string" ? /* @__PURE__ */ r.jsx("p", { children: l }) : l }),
        /* @__PURE__ */ r.jsx("span", { ref: X })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: j(d.popover, !c && d.popoverNoMaxWidth, e.popover), children: /* @__PURE__ */ r.jsxs(
        Re,
        {
          classes: {
            root: j(
              d.paper,
              { [d.paperBordered]: O === "bordered" },
              { [d.paperFocused]: O === "focused" },
              e.paper
            )
          },
          elevation: 0,
          square: !w,
          ...se,
          children: [
            /* @__PURE__ */ r.jsxs("div", { className: d.content, children: [
              /* @__PURE__ */ r.jsxs("div", { className: d.titleContainer, children: [
                k && /* @__PURE__ */ r.jsx(
                  V,
                  {
                    classes: { root: j(d.title, e.title) },
                    color: "primary",
                    component: q,
                    id: W,
                    variant: "h4",
                    children: k
                  }
                ),
                p && /* @__PURE__ */ r.jsx(
                  "button",
                  {
                    "aria-label": window.jQuery ? $.__("Close popover") : "Close popover",
                    className: j(d.closeButton, e.closeButton),
                    onClick: () => {
                      typeof b == "function" && (N(), b());
                    },
                    type: "button",
                    children: /* @__PURE__ */ r.jsx(je, { "aria-hidden": !0 })
                  }
                )
              ] }),
              /* @__PURE__ */ r.jsx("div", { className: j(d.constraint, e.constraint), children: /* @__PURE__ */ r.jsx("div", { id: Y, children: l && typeof l == "string" ? /* @__PURE__ */ r.jsx("p", { children: l }) : l }) })
            ] }),
            /* @__PURE__ */ r.jsx(
              "span",
              {
                className: I ? j(
                  d.arrow,
                  { [d.arrowBordered]: O === "bordered" },
                  { [d.arrowFocused]: O === "focused" },
                  e.arrow
                ) : void 0,
                ref: X
              }
            )
          ]
        }
      ) })
    );
    return /* @__PURE__ */ r.jsx(
      Ee,
      {
        anchorEl: t,
        "aria-labelledby": W,
        className: j(h, d.root, e.root),
        container: m,
        disablePortal: y,
        id: A,
        open: u,
        placement: _,
        ref: T,
        role: "dialog",
        transition: !0,
        ...de,
        "data-fabric-component": "Popover",
        modifiers: Be("name", ue, s),
        popperRef: C,
        children: ({ TransitionProps: n }) => /* @__PURE__ */ r.jsx(
          Fe,
          {
            onClickAway: () => {
              typeof b == "function" && !g && (N(), b());
            },
            children: /* @__PURE__ */ r.jsx(
              Ce,
              {
                onEnter: M,
                onEntered: F,
                onEntering: re,
                onExit: ne,
                onExited: ie,
                onExiting: ae,
                ...n,
                timeout: Ne,
                children: fe
              }
            )
          }
        )
      }
    );
  }
);
export {
  Fe as C,
  ot as P
};
//# sourceMappingURL=popover-DAJRG9vG.mjs.map
